module.exports = __webpack_public_path__ + "static/image 2-499ac12e582991bd47338e52bd97f672.png";